<mat-card class="p-20" style="width: max-content; max-width: 100%; box-sizing: border-box;">
  <mat-card-header>
    <div class="g-just-flex flex-between w-100 flex-wrap gap-30">
      <div class="left">
        <mat-card-title>Specimens</mat-card-title>
        <mat-card-subtitle>
          View available specimens for the selected patient. Add new specimens from the relevant lab request.
        </mat-card-subtitle>
      </div>
      <div class="right gap-10 g-just-flex">
        @if (canExport$ | async) {
        <a mat-flat-button extended class="secondary-button small-button" (click)="onExportSpecimens()">
          <mat-icon>file_download</mat-icon>
          Export
        </a>
        }
        @if (canAdd$ | async) {
        <a mat-flat-button extended (click)="onAddSpecimen()">
          <mat-icon>add</mat-icon>
          Add Specimen
        </a>
        }
      </div>
    </div>
  </mat-card-header>

  <mat-card-content class="mt-20">
    <app-table-header [patientsTableFilterArray]="specimenTableFilterArray"
      [patientsFiltersFormControlObject]="specimenFiltersFormControlObject"
      [searchableFields]="searchableFields"
      [selectedSearchField]="selectedSearchField"
      (filterChanged)="onFilterChanged($event)"
      (searchCriteriaChanged)="onSearchCriteriaChanged($event)">
    </app-table-header>
    <mat-divider></mat-divider>
    
    <div class="table-container" style="position: relative; min-height: 200px;">
      @if (searchService.loading$ | async) {
      <div class="loading-shade g-just-flex flex-center">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
      }

      @if ((searchService.total$ | async) !== 0) {
      <table mat-table matSort [dataSource]="searchService.dataSource" class="mat-elevation-z8 demo-table mt-20">
      <ng-container matColumnDef="identifier">
        <th mat-header-cell *matHeaderCellDef>Identifier</th>
        <td mat-cell *matCellDef="let specimen">
          <span class="small-subtitle" style="background: var(--mat-sys-surface-variant); color: var(--mat-sys-on-surface-variant); padding: 2px 6px; border-radius: 4px; display: inline-block;">
              {{ 'Specimen/' + specimen.id | referenceIdentifier | async }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="receivedTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="receivedTime">Received</th>
        <td mat-cell *matCellDef="let specimen">
          @if (specimen.receivedTime) {
          <div class="pt-3">
            {{ specimen.receivedTime | date: 'mediumDate' }}
          </div>
          <div class="pb-3 subtitle-text-color-2 small-subtitle">
            {{ specimen.receivedTime | date: 'shortTime' }}
          </div>
          } @else {
          <span class="subtitle-text-color-2">N/A</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</th>
        <td mat-cell *matCellDef="let specimen">
          @if (specimen.status) {
          <div [appChips]="specimen.status" [fontSize]="'14px'"></div>
          } @else {
          <span class="subtitle-text-color-2">N/A</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="type">Type</th>
        <td mat-cell *matCellDef="let specimen">
          {{ specimen.type | codeableConcept2 | na | titlecase }}
        </td>
      </ng-container>

      <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="subject">Patient</th>
        <td mat-cell *matCellDef="let specimen">
          @if (specimen.subject?.reference) {
          <div class="pt-3">
            <span [appReferenceDisplay]="specimen.subject.reference" InstantfetchAndRepace="true"></span>
          </div>
          <div class="pb-3 subtitle-text-color-2 small-subtitle">
            {{ specimen.subject.reference | referenceIdentifier | async }}
          </div>
          } @else {
          <span class="subtitle-text-color-2">N/A</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="request">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="request">Lab Request</th>
        <td mat-cell *matCellDef="let specimen">
          @if (specimen.request?.length) {
          <div class="pt-3">
            <span [appReferenceDisplay]="specimen.request[0].reference" InstantfetchAndRepace="true"></span>
          </div>
          <div class="pb-3 subtitle-text-color-2 small-subtitle">
            {{ specimen.request[0].reference | referenceIdentifier | async }}
          </div>
          } @else {
          <span class="subtitle-text-color-2">N/A</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let specimen">
          <button mat-icon-button [matMenuTriggerFor]="specimenMenu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #specimenMenu="matMenu">
            <button mat-menu-item (click)="showRow(specimen)">
              <mat-icon>visibility</mat-icon>
              <span>View Details</span>
            </button>
            <!-- <button mat-menu-item (click)="encounterService.addObservation(patientId || '', 'lab-test')">
              <mat-icon>science</mat-icon>
              <span>Record Result</span>
            </button> -->
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="specimenDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: specimenDisplayedColumns;"></tr>
    </table>

    <mat-paginator
      [length]="(searchService.total$ | async) || 0"
      [pageSize]="25"
      [pageSizeOptions]="[25]"
      (page)="searchService.changePage($event.pageIndex)"
      showFirstLastButtons>
    </mat-paginator>

    } @else {
    <app-empty-state class="py-40" [icon]="'SCIENCE'" [title]="'No Specimens Found'"
      [subtitle]="'No specimens are recorded for this patient yet.'">
    </app-empty-state>
    }
    </div>
  </mat-card-content>
</mat-card>